
import { defineComponent, ref } from 'vue';
import { useRouter } from 'vue-router';
import { default as Model } from '../../models/fishingKnotCategories.model';
import SubmitButton from '../../components/ui/SubmitButton.vue';
import FileUpload from '../../components/ui/FileUpload.vue';
import swal from '../../helper/swal.helper';

export default defineComponent({
  components: {
    SubmitButton,
    FileUpload,
  },
  setup() {
    const router = useRouter();
    const status = ref(true);
    const isSubmitting = ref(false);
    const categoryName = ref('');
    const orderNumber = ref();
    const thumbnailFile = ref<any>(null);

    async function submitForm() {
      isSubmitting.value = true;
      const category = {
        category_name: categoryName.value,
        is_show: status.value,
        order: orderNumber.value,
        icon: await thumbnailFile.value?.uploadImage(),
      };
      console.log(category);
      const addResult = await Model.create(category);
      if (addResult.status) {
        router.push('/fishing-knot-categories');
        isSubmitting.value = false;
      } else {
        swal.alert(addResult.message);
        isSubmitting.value = false;
      }
    }

    return {
      submitForm,
      categoryName,
      status,
      isSubmitting,
      thumbnailFile,
      orderNumber,
    };
  },
});
